//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/** @jsxImportSource @emotion/react */

export const communicationStyle = {
  slideimg: {
    height: '80px',
    width: '80px',
    pointerEvents: 'none' as const,
    marginLeft: '92px',
    paddingTop: '61px',
  },
  textInBox: {
    fontFamily: 'Inter',
    marginTop: '0px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '14px',
  },
  buttonText: {
    width: '130px',
    marginLeft: '92px',
    height: '36px',
    top: '453px',
    borderRadius: '2px',
    opacity: '1',
    border: '1px solid white',
    backgroundColor: '#4A4A56',
    color: 'white',
    marginTop: '10px',
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '26px',
    fontWeight: 500,
  },
  newsFeedContainer: {
    display: 'flex',
    width: '100%',
  },
  newsFeedLeft: {
    width: '60%',
  },
  newsFeedRight: {
    marginTop: '40px',
    paddingBottom: '20px',
  },
  slideContainer: {
    backgroundColor: '#4A4A56',
    marginLeft: '31px',
    marginRight: '31px',
    marginTop: '30px',
    color: 'white',
    borderRadius: '10px',
    border: '1px solid #A8A8BD',
    height: '480px',
  },
  myCommunicationsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '10px',
    paddingBottom: '6px',
  },
  myCommunicationsTitle: {
    width: '690px',
    height: '27px',
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '28px',
    color: 'white',
  },
  viewAllToggle: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17px',
    marginRight: '35px',
    color: 'white',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  newsCardContainer: {
    border: '1px solid #E4E4F0',
    borderRadius: '4px',
    marginRight: '70px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 4px 0px #BDBDBD1A',
    maxHeight: '620px',
    overflowY: 'auto',
  },
  title: {
    marginLeft: '92px',
    fontFamily: 'Inter',
    marginBottom: '0px',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '22px',
  },
  cardContainer: {
    borderRadius: '5px',
    color: 'black',
    marginLeft: '16px',
    marginTop: '16px',
    boxShadow: '0px 4px 4px 0px #BDBDBD1A',
  },
  appName: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#0550DC',
    border: '1px solid #EDF5FF',
    backgroundColor: '#EDF5FF',
    paddingLeft: '5px',
    paddingRight: '5px',
    margin: 5,
    display: 'inline-block',
  },
  newstitle: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '24px',
    width: '650px',
    margin: 2,
  },
  content: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    width: '100%',
    margin: 'auto',
    maxWidth: '100%',
  },
  date: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '19px',
    color: '#3D5466',
    marginTop: '8px',
  },
  divider: {
    marginRight: '21px',
    border: '1px solid #D3D3E5',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '20px',
  },
  imgRightContainer: { width: '40%', marginRight: '50px' },
  slideLeftText: { marginLeft: '92px', width: '450px' },
  imgRight: {
    width: '100%',
    height: '250px',
    marginTop: '30px',
  },
  dotsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
  },
  dot: (currentSlide: number, index: number) => ({
    height: '8px',
    width: '8px',
    backgroundColor: currentSlide === index ? 'white' : 'grey',
    borderRadius: '50%',
    display: 'inline-block',
    opacity: currentSlide === index ? '1' : '0.5',
    cursor: 'pointer',
  }),
  solutionCard: {
    border: '1px solid #E4E4F0',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 4px 0px #BDBDBD1A',
    display: 'flex',
    paddingBottom: '16px',
    alignItems: 'left',
    marginRight: '16px',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  solutionCardColorBar: {
    width: '100%',
    height: '4px',
    backgroundColor: '#4A4A56',
    borderRadius: '2px 2px 0px 0px',
  },
  solutionCardSvg: {
    width: '50px',
    height: '50px',
    marginTop: '16px',
  },
  solutionCardTitle: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    marginLeft: '16px',
    color: '#1D1D23',
  },
  solutionCardText: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px',
    marginBottom: '16px',
    marginLeft: '16px',
    marginRight: '16px',
    color: '#3F3F4A',
  },
  solutionCardButton: {
    width: '130px',
    height: '36px',
    borderRadius: '2px',
    border: '1px solid white',
    backgroundColor: 'rgb(0, 102, 176)',
    color: 'white',
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '26px',
    fontWeight: 500,
    cursor: 'pointer',
    marginBottom: '5px',
    marginLeft: '16px',
  },
  letsGoButton: {
    color: 'white',
    border: '0.8px solid #0550DC',
    width: 'auto',
    height: '28px',
    top: '445px',
    left: '92px',
    gap: '0px',
    background: 'rgb(0, 102, 176)',
    borderRadius: '4px',
    overflow: 'visible',
  },
  purchaseButton: {
    color: '#0550DC',
    width: 'auto',
    height: '28px',
    top: '658px',
    left: '357px',
    gap: '0px',
    borderRadius: '4px',
    opacity: '0px',
    background: 'white',
    border: '0.8px solid #0550DC',
  },
  pluginButtonContainer: {
    marginLeft: 'auto',
    flexShrink: 0,
  },
  pluginButton: {
    backgroundColor: 'rgb(0, 102, 176)',
    color: '#FFFFFF',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
    padding: '5px',
    fontFamily: 'Inter',
    outline: 'none',
    '&:focus': {
      outline: '2px solid #0550DC',
    },
  },
};
